import { getRequest } from 'utils/http'

export const getMemberRightSidebarApi = async () => {
  return getRequest(`/users/action-steps`)
}

export const getCoachRightSidebarApi = userId => {
  return getRequest(`/users/action-steps/${userId}`)
}
